import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IsoPortal } from '../models/iso-portal';
import { IsoPortalService } from '../services/iso-portal.service';

export const isoPortalResolverFn: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(IsoPortalResolver).resolve(route, state);
};

@Injectable({ providedIn: 'root' })
export class IsoPortalResolver {
  constructor(
    private isoPortalService: IsoPortalService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IsoPortal> {
    return this.isoPortalService.getIsoPortalData(route.queryParams.hash).pipe(
      catchError(error => {
        if (error.error.applicationId) {
          return of({ ...error.error, updateNeeded: true });
        }
        this.router.navigate(['/v2/error']);
        return EMPTY;
      })
    );
  }
}
